import React, { useState, useEffect, useCallback, useRef } from 'react'
import styles from './AutoLogoutTimer.module.scss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faRightFromBracket } from '@fortawesome/free-solid-svg-icons'

const AutoResetCheckout = ({ totalTime = 30, text = '' }) => {
  const [timeLeft, setTimeLeft] = useState(totalTime)
  const startTimeRef = useRef(Date.now())

  useEffect(() => {
    const update: any = () => {
      const now = Date.now()
      const endTime = startTimeRef.current + totalTime * 1000 // Recalculate the end time
      const timeRemaining = Math.max((endTime - now) / 1000, 0)

      setTimeLeft(timeRemaining)

      if (timeRemaining > 0) {
        requestAnimationFrame(update) // Continue animation
      }
    }

    update()

    return () => cancelAnimationFrame(update)
  }, [])

  const radius = 40 // Radius of the circle
  const circumference = 2 * Math.PI * radius // Circumference of the circle

  const progress = timeLeft / totalTime // Progress ratio
  const strokeDashoffset = circumference * (1 - progress) // Offset for stroke dash

  const progressWidth = `${(timeLeft / totalTime) * 100}%`

  return (
    <div className="">
      <svg width="44" height="44" viewBox="0 0 92 92">
        <defs>
          <linearGradient id="gradient" x1="0%" y1="100%" x2="100%" y2="0%">
            <stop offset="0%" stop-color="#462fee" />
            <stop offset="100%" stop-color="#800641" />
          </linearGradient>
        </defs>
        {/* Background circle */}
        <circle cx="48" cy="48" r={radius} fill="none" stroke="#e6e6e6" strokeWidth="8" />
        {/* Progress circle */}
        <circle
          cx="48"
          cy="48"
          r={radius}
          fill="none"
          stroke="url(#gradient)"
          strokeWidth="8"
          strokeDasharray={circumference}
          strokeDashoffset={strokeDashoffset}
          transform="rotate(-90 48 48)" // Rotates the circle so it starts at 12 o'clock
          style={{ transition: 'stroke-dashoffset 0.1s linear' }}
        />
        <text x="48" y="54" /* Zentriere den Text */ textAnchor="middle" fontSize="18" fill="#333">
          {`${Math.floor(timeLeft / 60) // Minuten
            .toString()
            .padStart(2, '0')}:${Math.floor(timeLeft % 60) // Sekunden
            .toString()
            .padStart(2, '0')}`}
        </text>
      </svg>
      <span className="ms-3">{text}</span>
    </div>
  )
}

export default AutoResetCheckout
